import React from 'react'
import ClipboardIcon from '../../../../../components/Images/ClipboardIcon'
import FacebookIcon from '../../../../../components/Images/FacebookIcon'
import FacebookMessengerIcon from '../../../../../components/Images/FacebookMessengerIcon'
import NovelsIcon from '../../../../../components/Images/NovelsIcon'
import TelegramIcon from '../../../../../components/Images/TelegramIcon'
import TwitterIcon from '../../../../../components/Images/TwitterIcon'
import WhatsappIcon from '../../../../../components/Images/WhatsappIcon'
import {
  isMobileOrTablet,
  redirectToNovelLinkHandler,
  redirectToShowLinkHandler,
} from '../../../../../lib/utils'
import { handleNewEventLog } from '../../../../../lib/utils/events'
import {
  LiveButton,
  NovelLiveContainer,
  LiveButtonText,
  ArrowRight,
  ShareContainerText,
  ShareContainer,
  ShareSocialGroup,
  ShareButton,
} from '../../styles'

const ShareBookModule = ({
  bookTitle,
  bookId,
  setIsUrlCopyToClipboard,
  bookDetails,
  user,
}) => {
  const isUgcBook = bookDetails?.is_novel === 2
  const shareLinkHandler = (appName) => {
    const id = isUgcBook ? bookDetails?.show_id : bookId
    const url = isUgcBook
      ? `https://www.pocketfm.com/show/${id} `
      : `https://www.pocketnovel.com/novel/${id}`
    let finalURL = ''
    const textWhileSharing = isUgcBook
      ? `Hey there! 🎧 Dive into my latest audio show ${bookTitle}`
      : bookTitle
    if (appName === 'whatsapp')
      finalURL =
        'https://' +
        (isMobileOrTablet() ? 'api' : 'web') +
        '.whatsapp.com/send?text=' +
        encodeURIComponent(textWhileSharing) +
        encodeURIComponent(': ') +
        encodeURIComponent(url)
    else if (appName === 'facebook')
      finalURL =
        'https://www.facebook.com/sharer/sharer.php?u=' +
        encodeURIComponent(url) +
        '&quote=' +
        encodeURIComponent(textWhileSharing)
    else if (appName === 'telegram')
      finalURL =
        'https://telegram.me/share/?url=' +
        encodeURIComponent(url) +
        '&text=' +
        encodeURIComponent(textWhileSharing)
    else if (appName === 'messenger')
      finalURL =
        'fb-messenger://share/?link=' +
        encodeURIComponent(url) +
        `&app_id=${id}`
    else if (appName === 'twitter')
      finalURL =
        'https://twitter.com/share?url=' +
        encodeURIComponent(url) +
        '&text=' +
        encodeURIComponent(textWhileSharing)
    // else if(appName === "instagram") finalURL = "https://www.instagram.com/?url=" + encodeURIComponent(url);
    else if (appName === 'clipboard') {
      setIsUrlCopyToClipboard(true)
      handleNewEventLog(
        'novels',
        'novels_novel_link_copied',
        {
          route: window.location.pathname + window.location.search,
          button: 'copy_share_url',
          module_name: 'share_novel_module',
        },
        user,
        bookDetails
      )
      if (isMobileOrTablet()) {
        var input = document.body.appendChild(document.createElement('input'))
        input.value = `${textWhileSharing}: ${url}`
        input.focus()
        input.select()
        document.execCommand('copy')
        input.parentNode.removeChild(input)
        return
      }
      navigator.clipboard.writeText(url)
    }
    if (appName !== 'clipboard') return finalURL
  }

  const handleNovelRedirection = () => {
    handleNewEventLog(
      'novels',
      'novels_novel_link_opened',
      {
        route: window.location.pathname + window.location.search,
        button: 'novel_is_live',
        module_name: 'share_novel_module',
      },
      user,
      bookDetails
    )
    if (isUgcBook) {
      redirectToShowLinkHandler(bookDetails?.show_id)
    } else {
      redirectToNovelLinkHandler(bookId)
    }
  }

  return (
    <NovelLiveContainer>
      <LiveButton onClick={handleNovelRedirection}>
        <LiveButtonText>
          <NovelsIcon width="20" height="20" />
          <span>
            {isUgcBook ? 'Your Audio Series Is Live' : 'Your Novel is live'}
          </span>
          <ArrowRight fill="#fdfdfd" />
        </LiveButtonText>
      </LiveButton>
      <ShareContainer>
        <ShareContainerText>Share: </ShareContainerText>
        <ShareSocialGroup
          onClick={() =>
            handleNewEventLog(
              'novels',
              'novels_novel_shared',
              {
                route: window.location.pathname + window.location.search,
                button: `share_btn`,
                module_name: 'share_module',
              },
              user,
              bookDetails
            )
          }
        >
          <ShareButton href={shareLinkHandler('whatsapp')} target="_blank">
            <WhatsappIcon width="32px" height="32px" />
          </ShareButton>
          <ShareButton href={shareLinkHandler('facebook')} target="_blank">
            <FacebookIcon width="32px" height="32px" />
          </ShareButton>
          {isMobileOrTablet() && (
            <ShareButton href={shareLinkHandler('messenger')} target="_blank">
              <FacebookMessengerIcon width="32px" height="32px" />
            </ShareButton>
          )}
          <ShareButton href={shareLinkHandler('twitter')} target="_blank">
            <TwitterIcon width="32px" height="32px" />
          </ShareButton>
          <ShareButton href={shareLinkHandler('telegram')} target="_blank">
            <TelegramIcon width="32px" height="32px" />
          </ShareButton>
          <ShareButton>
            <ClipboardIcon
              width="32px"
              height="32px"
              onClick={() => shareLinkHandler('clipboard')}
            />
          </ShareButton>
        </ShareSocialGroup>
      </ShareContainer>
    </NovelLiveContainer>
  )
}

export default ShareBookModule
